import { FC } from 'react';
import { Link } from 'react-router-dom';

import SunshineCard from 'components/_core/SunshineCard';

import * as routes from '../../../../routes';
import { formatExportNextDate } from '../../../../utils';
import { RecurringExports } from '../../hooks/useGetRecurringExports';
import locales from './locales';
import { formatExportRecipientName } from './utils';

interface RecurringExportsListProps {
  exports: RecurringExports;
}

const RecurringExportsList: FC<RecurringExportsListProps> = ({ exports }) => (
  <SunshineCard.Group border="none">
    {exports.map((exportItem) => {
      if (!exportItem) {
        return null;
      }

      return (
        <SunshineCard
          as={Link}
          key={exportItem.accountingRecurringExportId}
          paddingLeft="space-0"
          title={formatExportRecipientName(exportItem.recipient?.name)}
          to={routes.getExportPath(exportItem.accountingRecurringExportId)}
        >
          <SunshineCard.Content>
            <SunshineCard.Text>
              {locales.formatString(locales.nextDate, {
                nextDate: formatExportNextDate(),
              })}
            </SunshineCard.Text>
          </SunshineCard.Content>

          <SunshineCard.Slot name="action">
            <SunshineCard.SunshineIcon name="chevron-right" />
          </SunshineCard.Slot>
        </SunshineCard>
      );
    })}
  </SunshineCard.Group>
);

export default RecurringExportsList;
